"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var UILoginWidget = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UILoginWidget, _PureComponent);
  var _super = _createSuper(UILoginWidget);
  function UILoginWidget() {
    (0, _classCallCheck2.default)(this, UILoginWidget);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(UILoginWidget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var jsSource = '/auth/login-sdk/sdk.',
        jsSourceExtension = '.js',
        jsScriptTag = 'script',
        loginSDKText = 'login-jssdk',
        loginText = 'login',
        _this$props = this.props,
        loginWidgetTheme = _this$props.loginWidgetTheme,
        loginButtonText = _this$props.loginButtonText,
        loginWidgetContainerName = _this$props.loginWidgetContainerName,
        redirectURL = _this$props.redirectURL,
        etid = _this$props.etid,
        _this$props$isSourceA = _this$props.isSourceAspen,
        isSourceAspen = _this$props$isSourceA === void 0 ? false : _this$props$isSourceA,
        realm = _this$props.realm,
        width = _this$props.width,
        height = _this$props.height;
      if (!window.widgetFactory) window.widgetFactory = [];
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.async = true;
        js.src = jsSource + Date.now() + jsSourceExtension;
        fjs.parentNode.insertBefore(js, fjs);
      })(document, jsScriptTag, loginSDKText);
      window.widgetFactory.push([loginText, function (loginSDK) {
        loginSDK.createWidget({
          options: {
            container: document.getElementById(loginWidgetContainerName),
            theme: loginWidgetTheme,
            loginButtonText: loginButtonText,
            // default to 'View My Offers' by auth-ui
            fadeInOnLoad: true,
            targetURL: redirectURL || '',
            etid: etid || '',
            isSourceAspen: isSourceAspen,
            realm: realm,
            width: width,
            height: height
          },
          // Handle Login
          onLogin: function onLogin(err, response) {
            if (err) {
              // Error handling by default is done in the login
              // If you must override it, do so here.
            } else {
              // Redirect logged in user
              // if not present, defaults to account summary
              window.location.href = redirectURL || '';
            }
          },
          onRenderWidgetError: function onRenderWidgetError(loginWidgetIFrame) {
            loginWidgetIFrame.hidden = true;
          }
        });
      }]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        signinHeaderText = _this$props2.signinHeaderText,
        loginWidgetContainerName = _this$props2.loginWidgetContainerName,
        loginFormContainerName = _this$props2.loginFormContainerName;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: loginFormContainerName
      }, signinHeaderText ? /*#__PURE__*/_react.default.createElement("h2", null, signinHeaderText) : '', /*#__PURE__*/_react.default.createElement("div", {
        id: loginWidgetContainerName,
        className: loginWidgetContainerName
      })));
    }
  }]);
  return UILoginWidget;
}(_react.PureComponent);
(0, _defineProperty2.default)(UILoginWidget, "defaultProps", {
  loginWidgetTheme: 'lc-blue',
  realm: 'lc',
  loginWidgetContainerName: 'login-widget-container',
  loginFormContainerName: 'login-form-container',
  width: '290',
  height: '261'
});
UILoginWidget.propTypes = {
  loginWidgetTheme: _propTypes.default.string.isRequired,
  redirectURL: _propTypes.default.string,
  etid: _propTypes.default.string,
  realm: _propTypes.default.string.isRequired,
  loginButtonText: _propTypes.default.string,
  signinHeaderText: _propTypes.default.string,
  loginWidgetContainerName: _propTypes.default.string,
  loginFormContainerName: _propTypes.default.string,
  isSourceAspen: _propTypes.default.bool,
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
var _default = UILoginWidget;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/ui-login-widget/dist/ui-login-widget.scss');